import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import * as moment from 'moment';
import { AiOutlineSearch } from "react-icons/ai";
import TooltipMaterial from "@material-ui/core/Tooltip";
import { useDispatch, useSelector } from 'react-redux';
import axioPath from '../../../../../api/axioPath';
import Spinner from '../../../../components/Spinner'
import CommentBoxModal from "web/components/CommentBoxModal";
import { allOpenOrdersList, allCancelledOrdersList } from '../../../../../redux/actions/admin';
import { SearchWrapper, SelectWrapper, Header, TableSection } from '../DashBoard/dashBoardStyled'
import { Heading, TableWrapper } from 'web/pages/private/Admin/adminStyled'
import CsvDownloader from 'react-csv-downloader';

import { Table } from 'reactstrap';
import Pagination from '@material-ui/lab/Pagination';

import Typography from '@material-ui/core/Typography';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import HOCButton from 'web/components/Button';
import { storeAdminDetails, logoutAdmin } from 'redux/actions/admin';

import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import styled from 'styled-components';
import styles from './cancelOrders.module.scss'
import { stateConvert } from 'web/components/utils/stateAbbreviation';
import DatePicker from 'web/components/DatePicker';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const buttonStyle = { background: '#61b01f', background: 'linear-gradient(to bottom, #61b01f 0%,#27911b 100%)', color: 'white', whiteSpace: 'nowrap', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '2px', cursor: 'pointer',height: '42px', marginBottom: '6px'}
const disabledButtonStyle = { background: '#61b01f', background: 'linear-gradient(to bottom, #61b01f 0%,#27911b 100%)', color: 'white', whiteSpace: 'nowrap', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '2px', opacity: 0.5,height: '42px', marginBottom: '6px' }

function CancelOrders() {
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const dispatch = useDispatch();
    let history = useHistory()
    const [value, setValue] = useState(0);
    const [modal, setModal] = useState(false);
    const adminRoles = useSelector(state => state.admin.adminRoles)
    const [modalMessage, setModalMessaage] = useState('')
    const [cancelConfirmationModal, setCancelConfirmationModal] = useState(false);
    const [selectedCancelId, setSelectedCancelId] = useState('')
    const [finalData, setFinalData] = useState([])
    const [tableSearch, setTableSearch] = useState('')
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);

    const [commentModal, setCommentModal] = useState(false)
    const commentToggleModal = () => setCommentModal(!commentModal)

    // cancelled orders tab
    const [finalDataCancelled, setFinalDataCancelled] = useState([])
    const [tableSearchCancelled, setTableSearchCancelled] = useState('')
    const [pageCancelled, setPageCancelled] = useState(1);
    const [pageCountCancelled, setPageCountCancelled] = useState(0);

    const [totalDataCountOpen, setTotalDataCountOpen] = useState();
    const [totalDataCountCancelled, setTotalDataCountCancelled] = useState();

    let toDateCancelOrders = new Date();
    let fromDateCancelOrders = new Date();
    fromDateCancelOrders.setMonth(fromDateCancelOrders.getMonth() - 1)
    toDateCancelOrders.setMonth(toDateCancelOrders.getMonth() + 1)
    const [startDateValue, setStartDateValue] = useState(moment(fromDateCancelOrders).format("MM/DD/YYYY"))
    const [endDateValue, setEndDateValue] = useState(moment(toDateCancelOrders).format("MM/DD/YYYY"))

    const [userFilterState, setUserFilterState] = useState({
        fromDate: moment(fromDateCancelOrders).format("YYYY-MM-DD"),
        toDate: moment(toDateCancelOrders).format("YYYY-MM-DD"),
    });

    //change tab index
    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
        //set date default
        let toDateCancelOrders = new Date();
        let fromDateCancelOrders = new Date();
        fromDateCancelOrders.setMonth(fromDateCancelOrders.getMonth() - 1)
        toDateCancelOrders.setMonth(toDateCancelOrders.getMonth() + 1)
        setUserFilterState(prevState => ({
            ...prevState,
            ["fromDate"]: moment(fromDateCancelOrders).format("YYYY-MM-DD"),
            ["toDate"]: moment(toDateCancelOrders).format("YYYY-MM-DD"),
        }))
        setStartDateValue(moment(fromDateCancelOrders).format("MM/DD/YYYY"))
        setEndDateValue(moment(toDateCancelOrders).format("MM/DD/YYYY"))
    };

    useEffect(() => {
        let userRole = localStorage.getItem('accountType')
        let appUserRolesList = ['Both', 'Buyer', 'Seller']
        if (userRole !== 'Admin') {
            if (appUserRolesList.includes(userRole)) history.push('/dashboard')
            else history.push('/sign-in')
            window.location.reload();
        }
        fetchOrderListAPI(1, '');
        fetchCancelledOrderListAPI(1, '');
    }, []);

    const fetchOrderListAPI = async (pageNo, search) => {
        let response = '';
        if ((!userFilterState.fromDate|| !userFilterState.toDate)) {
            setModalMessaage("Please enter the correct Date Range.")
            setModal(!modal)
            return
        } else {
            response = await dispatch(allOpenOrdersList(10, pageNo, search, userFilterState.fromDate, userFilterState.toDate));
            if (response && response.status === 'SUCCESS') {
                if (response.payload && response.payload.orders && response.payload.orders.content) {
                    let adminOrderList = response.payload.orders.content
                    setFinalData(adminOrderList)
                    setPageCount(response.payload.orders.totalPages)
                    setTotalDataCountOpen(response.payload.orders.totalElements)
                }
            } else {
                if (response.statusCode === 401) {
                    adminLogout()
                } else {
                    setModalMessaage(response.message)
                    setModal(!modal)
                }
            }
        }
    };

    const adminLogout = () => {
        localStorage.removeItem('token')
        history.push('/sign-in')
        window.location.reload(false);
    }
    const fetchCancelledOrderListAPI = async (pageNo, search) => {
        let response = '';

        if ((!userFilterState.fromDate|| !userFilterState.toDate)) {
            setModalMessaage("Please enter the correct Date Range.")
            setModal(!modal)
            return
        }
        response = await dispatch(allCancelledOrdersList(10, pageNo, search, userFilterState.fromDate, userFilterState.toDate));
        if (response && response.status === 'SUCCESS') {
            if (response.payload && response.payload.orders && response.payload.orders.content) {
                let adminOrderList = response.payload.orders.content
                setFinalDataCancelled(adminOrderList)
                setPageCountCancelled(response.payload.orders.totalPages)
                setTotalDataCountCancelled(response.payload.orders.totalElements)
            }
        } else {
            if (response.statusCode === 401) {
                adminLogout()
            } else {
                setModalMessaage(response.message)
                setModal(!modal)
            }
        }

    };

    //handle page change in open orders section
    const handlePageChange = (event, value) => {
        if ((!userFilterState.fromDate || !userFilterState.toDate)) {
            setModalMessaage("Date fields should be valid.")
            setModal(!modal)
        } else {
            setPage(value);
            fetchOrderListAPI(value, tableSearch)
        }
    };

    //handle page change in cancelled orders section
    const handlePageChangeCancelled = (event, value) => {
        if ((!userFilterState.fromDate || !userFilterState.toDate)) {
            setModalMessaage("Date fields should be valid.")
            setModal(!modal)
        } else {
            setPageCancelled(value);
            fetchCancelledOrderListAPI(value, tableSearchCancelled)
        }
    };

    const handleToggle = () => {
        setModal(!modal);
    }

    const handleSearchChange = e => {
        e.preventDefault()
        setTableSearch(e.target.value)
        const search = e.target.value
        setPage(1)
        setPageCancelled(1)
        fetchOrderListAPI(1, search)
    }

    const handleSearchChangeCancelled = e => {
        e.preventDefault()
        setTableSearchCancelled(e.target.value)
        const search = e.target.value
        setPage(1)
        setPageCancelled(1)
        fetchCancelledOrderListAPI(1, search)
    }

    let headerArr = [
        { title: 'Order ID', },
        { title: 'Buyer Company Name', },
        { title: 'Buyer City', },
        { title: 'Buyer State', },
        { title: 'Buyer Zip', },
        { title: 'Buyer Broker', },
        { title: 'Buyer FC Member', },
        { title: 'Seller Company Name', },
        { title: 'Seller City', },
        { title: 'Seller State', },
        { title: 'Seller Zip', },
        { title: 'Seller Broker', },
        { title: 'Seller FC Member', },
        { title: 'Order Status', },
        { title: 'Order Quantity', },
        { title: 'Requested Date', },
        { title: 'Action', },       
    ];

    let headerArrCancelled = [
        { title: 'Order ID', },
        { title: 'Buyer Company Name', },
        { title: 'Buyer City', },
        { title: 'Buyer State', },
        { title: 'Buyer Zip', },
        { title: 'Buyer Broker', },
        { title: 'Buyer FC Member', },
        { title: 'Seller Company Name', },
        { title: 'Seller City', },
        { title: 'Seller State', },
        { title: 'Seller Zip', },
        { title: 'Seller Broker', },
        { title: 'Seller FC Member', },
        { title: 'Order Status', },
        { title: 'Order Quantity', },
        { title: 'Requested Date', },
        { title: 'Comment', }
    ];

    let openColumns = [
        { id: 'OrderID', displayName: 'Order ID' },
        { id: 'BuyerCompanyName', displayName: 'Buyer Company Name' },
        { id: 'BuyerCity', displayName: 'Buyer City' },
        { id: 'BuyerState', displayName: 'Buyer State' },
        { id: 'BuyerZip', displayName: 'Buyer Zip' },
        { id: 'BuyerBroker', displayName: 'Buyer Broker' },
        { id: 'BuyerFCMember', displayName: 'Buyer FC Member' },
        { id: 'SellerCompanyName', displayName: 'Seller Company Name' },
        { id: 'SellerCity', displayName: 'Seller City' },
        { id: 'SellerState', displayName: 'Seller State' },
        { id: 'SellerZip', displayName: 'Seller Zip' },
        { id: 'SellerBroker', displayName: 'Seller Broker' },
        { id: 'SellerFCMember', displayName: 'Seller FC Member' },
        { id: 'OrderStatus', displayName: 'Order Status' },
        { id: 'OrderQuantity', displayName: 'Order Quantity' },
        { id: 'RequestedDate', displayName: 'Requested Date' },
    ];

    let cancelledColumns = [
        { id: 'OrderID', displayName: 'Order ID' },
        { id: 'BuyerCompanyName', displayName: 'Buyer Company Name' },
        { id: 'BuyerCity', displayName: 'Buyer City' },
        { id: 'BuyerState', displayName: 'Buyer State' },
        { id: 'BuyerZip', displayName: 'Buyer Zip' },
        { id: 'BuyerBroker', displayName: 'Buyer Broker' },
        { id: 'BuyerFCMember', displayName: 'Buyer FC Member' },
        { id: 'SellerCompanyName', displayName: 'Seller Company Name' },
        { id: 'SellerCity', displayName: 'Seller City' },
        { id: 'SellerState', displayName: 'Seller State' },
        { id: 'SellerZip', displayName: 'Seller Zip' },
        { id: 'SellerBroker', displayName: 'Seller Broker' },
        { id: 'SellerFCMember', displayName: 'Seller FC Member' },
        { id: 'OrderStatus', displayName: 'Order Status' },
        { id: 'OrderQuantity', displayName: 'Order Quantity' },
        { id: 'RequestedDate', displayName: 'Requested Date' },
        { id: 'Comment', displayName: 'Comment' },
    ];


    const cancelOrder = (id,comment) => {
       // e.preventDefault()
        const token = localStorage.getItem("token")
        // let url = ''
        // url = `order/admin/cancelorder?orderId=${id}`
        // setCancelConfirmationModal(false)
        // axioPath.get(url, {
        //     headers: {
        //         Authorization: token,
        //     },
        // }).then((response) => {
        //     if (response.data?.message === "Full authentication is required to access this resource") {
        //         history.push('/sign-in');
        //     } else {
        //         fetchOrderListAPI(page, tableSearch)
        //         setModalMessaage(response.data.message ? response.data.message : 'Process Failed')
        //         setModal(!modal)
        //     }
        // }).catch((ex) => {
        //     setModalMessaage(ex.message)
        //     setModal(!modal)
        // });

        let data = {
            orderId:id,
            comment:comment
        }

        axioPath
        .post('/order/admin/cancelorder', data, {
            headers: {
                Authorization: `${token}`,
            },
        }).then((response) => {
            if (response.data?.message === "Full authentication is required to access this resource") {
                history.push('/sign-in');
            } else {
                fetchOrderListAPI(page, tableSearch)
                setModalMessaage(response.data.message ? response.data.message : 'Process Failed')
                setModal(!modal)
            }
        }).catch((ex) => {
            setModalMessaage(ex.message)
            setModal(!modal)
        });
    }

    const getOrderCsvData = async () => {
        let response
        if ((!userFilterState.fromDate || !userFilterState.toDate)) {
            setModalMessaage("Please enter the correct Date Range.")
            setModal(!modal)
            return
        } 
        if (value === 0) response = await dispatch(allOpenOrdersList(totalDataCountOpen, 1, tableSearch, userFilterState.fromDate, userFilterState.toDate));
        else response = await dispatch(allCancelledOrdersList(totalDataCountCancelled, 1, tableSearchCancelled, userFilterState.fromDate, userFilterState.toDate));

        if (response && response.status === 'SUCCESS') {
            if (response.payload && response.payload.orders && response.payload.orders.content) {
                let responseData = response.payload.orders.content
                let exportData = responseData.map(items => {
                    return ({
                        OrderID: items.id,
                        BuyerCompanyName: items.buyerInfo?.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                        BuyerCity: items.buyerInfo?.address?.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," ")?.trim(),
                        BuyerState: stateConvert(items.buyerInfo?.address?.state?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," ")),
                        BuyerZip: items.buyerInfo?.address?.zip?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                        BuyerBroker: items.buyerIsReseller ? 'Yes' : 'No',
                        BuyerFCMember: items.buyerInnerCircle ? 'Yes' : 'No',
                        SellerCompanyName: items.sellerInfo?.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                        SellerCity: items.sellerInfo?.address?.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.trim(),
                        SellerState: stateConvert(items.sellerInfo?.address?.state?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," ")),
                        SellerZip: items.sellerInfo?.address?.zip?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                        SellerBroker: items.sellerIsReseller ? 'Yes' : 'No',
                        SellerFCMember: items.sellerInnerCircle ? 'Yes' : 'No',
                        OrderStatus: items.orderStatus === 'CANCELLED' ? 'CANCELED' : items.orderStatus,
                        OrderQuantity: items.orderDetails?.quantity,
                        RequestedDate: items.contactInfo?.requestedDate ? moment(items.contactInfo.requestedDate).format("MM/DD/YYYY") : 'NA',
                        Comment: items?.orderCancelDetails?.description
                    })
                })
                return exportData
            }
        } else {
            if (response.statusCode === 401) {
                adminLogout()
            } else {
                setModalMessaage(response.message || 'Something went wrong, please try again!')
                setModal(!modal)
            }
        }
    }

    return (
        <>
            {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('RETRY_ORDER'))) ?
                <Container>
                    <TableWrapper>
                        {(loaderVisible) && <Spinner />}
                        <div class="column">
                            <Heading>
                                <h3>Cancel Orders</h3>
                                <div className='d-flex flex-wrap flex-sm-nowrap'>
                                    <SearchWrapper>
                                        <input type="text" placeholder='Search' value={value === 0 ? tableSearch : tableSearchCancelled}
                                            onChange={value === 0 ? handleSearchChange : handleSearchChangeCancelled} />
                                        <AiOutlineSearch />
                                    </SearchWrapper>
                                    <CsvDownloader
                                        filename={value === 0 ? 'Open Order Report' : 'Canceled Order Report'}
                                        columns={value === 0 ? openColumns : cancelledColumns}
                                        datas={value === 0 ? getOrderCsvData : getOrderCsvData}>
                                        <button
                                            style={buttonStyle}>
                                            Export
                                        </button>
                                    </CsvDownloader>

                                </div>
                            </Heading>
                            <InnerHeader>
                            <DateWrapper>
                                    <label>From</label>
                                    <DatePicker
                                        name="fromDateCancelOrders"
                                        placeholderText=""
                                        maxDOBirth={userFilterState.toDate}
                                        value={userFilterState.fromDate}
                                        inputValue={startDateValue}
                                        callBackFun={(date, value) => {
                                            setStartDateValue(value)
                                            if (moment(date, moment.ISO_8601, true).isValid()) {
                                                setUserFilterState((prevState) => ({
                                                    ...prevState,
                                                    ["fromDate"]: moment(date).format("YYYY-MM-DD"),
                                                }));
                                            } else if (!date || date?.toString() === "Invalid Date") { // Check if date is null or undefined
                                                setUserFilterState((prevState) => ({
                                                    ...prevState,
                                                    ["fromDate"]: null,
                                                }));
                                            }
                                        }}
                                    />
                                </DateWrapper>
                                <DateWrapper>
                                    <label>To</label>
                                    <DatePicker
                                        name="toDateCancelOrders"
                                        placeholderText=""
                                        minDOBirth={userFilterState.fromDate}
                                        value={userFilterState.toDate}
                                        inputValue={endDateValue}
                                        callBackFun={(date, value) => {
                                            setEndDateValue(value)
                                            if (moment(date, moment.ISO_8601, true).isValid()) {
                                                setUserFilterState((prevState) => ({
                                                    ...prevState,
                                                    ["toDate"]: moment(date).format("YYYY-MM-DD"),
                                                }));
                                            } else if (!date || date?.toString() === "Invalid Date") { // Check if date is null or undefined
                                                setUserFilterState((prevState) => ({
                                                    ...prevState,
                                                    ["toDate"]: null,
                                                }));
                                            }
                                        }}
                                    />
                                </DateWrapper>
                                    <button
                                        disabled={userFilterState.fromDate === '' || userFilterState.toDate === ''}
                                        style={(userFilterState.fromDate === '' || userFilterState.toDate === '') ? disabledButtonStyle : buttonStyle}
                                        onClick={() => {
                                            setPage(1)
                                            setPageCancelled(1)
                                            fetchOrderListAPI(1, tableSearch);
                                            fetchCancelledOrderListAPI(1, tableSearchCancelled);
                                        }}
                                    >
                                        Submit
                                    </button>
                                </InnerHeader>
                            </div>

                        <AppBar position="static">
                            <Tabs value={value} onChange={handleChangeTab} aria-label="simple tabs example">
                                <Tab label="Open Orders" {...a11yProps(0)} />
                                <Tab label="Canceled Orders" {...a11yProps(1)} />
                            </Tabs>
                        </AppBar>

                        <TabPanel value={value} index={0}>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        {headerArr.map((items, index) => (
                                            <th key={index}>{items.title}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        finalData.map((items, index) => (
                                            <tr className={styles.homeWrapper} key={index}>
                                                <td>{items.id}</td>
                                                <td>{items.buyerInfo?.companyName}</td>
                                                <td>{items.buyerInfo?.address?.city?.trim()}</td>
                                                <td>{stateConvert(items.buyerInfo?.address?.state)}</td>
                                                <td>{items.buyerInfo?.address?.zip}</td>
                                                <td>{items.buyerIsReseller ? 'Yes' : 'No'}</td>
                                                <td>{items.buyerInnerCircle ? 'Yes' : 'No'}</td>
                                                <td>{items.sellerInfo && items.sellerInfo.companyName}</td>
                                                <td>{items.sellerInfo?.address?.city?.trim()}</td>
                                                <td>{stateConvert(items.sellerInfo?.address?.state)}</td>
                                                <td>{items.sellerInfo?.address?.zip}</td>
                                                <td>{items.sellerIsReseller ? 'Yes' : 'No'}</td>
                                                <td>{items.sellerInnerCircle ? 'Yes' : 'No'}</td>
                                                <td>{items.orderStatus === 'CANCELLED' ? 'CANCELED' : items.orderStatus}</td>
                                                <td>{items.orderDetails.quantity}</td>
                                                <td>{(items.contactInfo && items.contactInfo.requestedDate) ? moment(items.contactInfo.requestedDate).format("MM/DD/YYYY") : 'NA'}</td>
                                                <td>
                                                    <HOCButton
                                                        type='app-green-button submitBtn'
                                                        handleClick={() => {
                                                            setSelectedCancelId(items.id)
                                                            commentToggleModal()
                                                            // setCancelConfirmationModal(true)
                                                        }}
                                                    >
                                                        Cancel Order
                                                    </HOCButton>
                                                </td>                                                
                                            </tr>
                                        ))}
                                </tbody>
                            </Table>
                            {finalData.length !== 0 && <Pagination count={pageCount}
                                page={page}
                                onChange={handlePageChange} />}
                        </TabPanel>

                        <TabPanel value={value} index={1}>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        {headerArrCancelled.map((items, index) => (
                                            <th key={index}>{items.title}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        finalDataCancelled.map((items, index) => (
                                            <tr className={styles.homeWrapper} key={index}>
                                                <td>{items.id}</td>
                                                <td>{items.buyerInfo?.companyName}</td>
                                                <td>{items.buyerInfo?.address?.city?.trim()}</td>
                                                <td>{stateConvert(items.buyerInfo?.address?.state)}</td>
                                                <td>{items.buyerInfo?.address?.zip}</td>
                                                <td>{items.buyerIsReseller ? 'Yes' : 'No'}</td>
                                                <td>{items.buyerInnerCircle ? 'Yes' : 'No'}</td>
                                                <td>{items.sellerInfo && items.sellerInfo.companyName}</td>
                                                <td>{items.sellerInfo?.address?.city?.trim()}</td>
                                                <td>{stateConvert(items.sellerInfo?.address?.state)}</td>
                                                <td>{items.sellerInfo?.address?.zip}</td>
                                                <td>{items.sellerIsReseller ? 'Yes' : 'No'}</td>
                                                <td>{items.sellerInnerCircle ? 'Yes' : 'No'}</td>
                                                <td>{items.orderStatus === 'CANCELLED' ? 'CANCELED' : items.orderStatus}</td>
                                                <td>{items.orderDetails.quantity}</td>
                                                <td>{(items.contactInfo && items.contactInfo.requestedDate) ? moment(items.contactInfo.requestedDate).format("MM/DD/YYYY") : 'NA'}</td>
                                                <td>
                                                    {items?.orderCancelDetails?.description && <TooltipMaterial
                                                        placement="top"
                                                        arrow
                                                        title={items?.orderCancelDetails?.description}
                                                        enterTouchDelay={0}
                                                    >
                                                        <span className={"remark"}>{items?.orderCancelDetails?.description}</span>
                                                    </TooltipMaterial>}
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </Table>
                            {finalDataCancelled.length !== 0 && <Pagination count={pageCountCancelled}
                                page={pageCancelled}
                                onChange={handlePageChangeCancelled} />}
                        </TabPanel>

                    </TableWrapper>

                    <Modal isOpen={modal} centered={true}>
                        <ModalHeader toggle={handleToggle}><h6>Status</h6></ModalHeader>
                        <ModalBody>
                            {modalMessage}
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={handleToggle}>OK</Button>
                        </ModalFooter>
                    </Modal>

                    {/* <Modal isOpen={cancelConfirmationModal} centered={true}>
                        <ModalHeader toggle={e => {
                            setCancelConfirmationModal(!cancelConfirmationModal)
                            setSelectedCancelId('')
                        }}>
                            <h6>Cancel Confirmation</h6>
                        </ModalHeader>
                        <ModalBody>
                            Are you sure you want to cancel this order?
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={e => cancelOrder(e, selectedCancelId)}>Yes</Button>
                            <Button color="secondary" onClick={e => {
                                setCancelConfirmationModal(!cancelConfirmationModal)
                                setSelectedCancelId('')
                            }}>
                                No
                            </Button>
                        </ModalFooter>
                    </Modal> */}

                    <CommentBoxModal
                        isOpen={commentModal}
                        toggle={commentToggleModal}
                        title=""
                        content="Are you sure you want to cancel this order?"
                        onClickHander={(comment) => {
                        if (comment === "no"){
                        }
                        else{
                            if(comment){
                                cancelOrder(selectedCancelId,comment)
                            }
                        
                        }
                        }}
                        link="/"
                    />

                </Container >

                :
                <p>You are not authorized to view this page.</p>
            }
        </>

    )
};

export default CancelOrders;

const Container = styled.div`
        
        /* .MuiTabs-flexContainer {
                            border-bottom: 4px solid #e8e8e8;
        } */
        `

const InnerHeader = styled.div`
    min-height: 50px;
    display: flex;
    padding: 0 20px;
    align-items: flex-end;
    border-bottom: solid 1px #97979729;
    padding: 0 20px;
    gap: 10px;
    padding-bottom: 15px;
    flex-wrap: wrap;
    margin-top:1rem;
`
const DateWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  input {
    padding: 5px;
    border: solid 1px transparent !important;
    margin: 2px 0;
    font-size: 16px;
    padding: 5px 13px;
    border-radius: 5px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    min-width: 130px;
    max-width: 150px;
    max-height: 42px;
    ::-webkit-input-placeholder {
      /* Edge */
      color: #656565;
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #656565;
    }

    ::placeholder {
      color: #656565;
    }
  }
  label {
    padding: 8px 8px 8px 0px;
    font-size: 16px;
    @media (max-width: 465px){
        min-width: 60px;
    }
  }
`;